import { Progress } from "antd";
import * as React from "react";
import "./style.scss";
interface ProgressBarProps {
  className: string;
  percent: number;
  strokeWidth: number;
}

export class ProgressBar extends React.Component<any, {}> {
  render() {
    return <Progress {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Progress/ProgressBar/index.tsx